<template>
  <!--중복 객체 처리 팝업-->
  <confirm-dialog ref="confirmDialog"
                  :prevent-close="true"
                  :footer-btn-list="btnList"
                  @onYes="onYes"
                  @onNo="onNo"
  />
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'
  import ConfirmDialog from '~/components/dialog/ConfirmDialog'
  const commonHelper = createNamespacedHelpers('cm/objectSecProfile/object/objectSettings/common')
  export default {
    name: 'DuplicateConfirmDialog',
    data () {
      return {
        buttons: [],
        btnList: [
          {
            text: this.$t('op.no'),
            color: 'dark',
            type: 'no'
          },
          {
            text: this.$t('op.yes'),
            color: 'primary',
            type: 'yes'
          }
        ],
        popupResult: void 0
      }
    },
    components: {
      ConfirmDialog
    },
    computed: {
      ...commonHelper.mapState([
        'objectType'
      ])
    },
    methods: {
      show ({msg}) {
        let content = ''
        if (msg) {
          if (this.objectType === 'service') {
            content = msg + this.$t('op.objectDuplicateCheckPopupOfService')
          } else {
            content = msg + this.$t('op.objectDuplicateCheckPopup')
          }
        }
        this.$refs.confirmDialog.show(content)
        return new Promise((resolve) => {
          this.popupResult = resolve
        })
      },
      onYes () {
        if (!this.popupResult) return
        this.popupResult(true)
        this.initPopupResult()
      },
      onNo () {
        if (!this.popupResult) return
        this.popupResult(false)
        this.initPopupResult()
      },
      initPopupResult () {
        this.popupResult = void 0
      }
    }
  }
</script>
